<template>
    <div id="main">
        <loader v-if="isLoading" />
        <!-- CONTAINER DE ALERTAS -->
        <alert-container :messages="msgs" />
        <div class="listing-header mb-3">
            <div class="title-breadcrumb">
                <h1 class="title">
                    <span v-if="isUpdate"> {{ $t('editar') }} {{ $t('aba-estoque') }} </span>
                    <span v-else> {{ $t('cadastrar') }} {{ $t('aba-estoque') }} </span>
                </h1>
            </div>
            <div class="header-buttons">
                <button class="delete-btn" type="button" @click="fecharModal()">
                    {{ $t('cancelar') }}
                </button>
                <button
                    v-if="
                        (!integracao && !isUpdate && permissao.create) ||
                        (!integracao && isUpdate && permissao.update)
                    "
                    @click="save"
                    :disabled="isSaving || cantEdit"
                    class="save-btn"
                    type="button"
                >
                    {{ $t('salvar') }}
                    <button-loader :isSaving="isSaving" />
                </button>
            </div>
        </div>
        <br />

        <div class="form-columns-fit">
            <div class="columns is-flex-wrap">
                <div class="column is-6">
                    <vss-select
                        :id="generateId(1)"
                        ref="empresaSelect"
                        title="empresas"
                        label="nome"
                        :options="empresaSelect"
                        v-model="empresaSelected"
                        required
                        :invalid="empresaSelected == null"
                        :disabled="isUpdate || cantEdit"
                    />
                </div>
                <div class="column is-6">
                    <v-input
                        :id="generateId(3)"
                        ref="saldoInput"
                        v-model="estoque.saldo"
                        title="saldo"
                        placeholder="placeholder-preencha"
                        :invalid="isNull(estoque.saldo)"
                        required
                        v-mask="['#######']"
                        :disabled="cantEdit"
                    />
                </div>
                <div class="column is-6">
                    <v-input
                        :id="generateId(6)"
                        ref="saldominimoInput"
                        v-model="estoque.saldominimo"
                        title="saldominimo"
                        placeholder="placeholder-preencha"
                        :invalid="isNull(estoque.saldominimo)"
                        required
                        v-mask="['#######']"
                        :disabled="cantEdit"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SaldoProdutoService from '@/services/vendas/produto/SaldoProdutoService';
import EmpresaService from '@/services/vendas/empresa/EmpresaService.js';
import Message from '@/models/Message';
import SaldoProdutoValidation from '@/services/validations/vendas/produto/SaldoProdutoValidation';

export default {

    props: {
        idsaldoproduto: {
            type: Number,
            default: null,
        },
        integracao: {
            type: Boolean,
            default: true,
        },
        permissao: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            service: new SaldoProdutoService(this.$http, this.$router),
            empresaService: new EmpresaService(this.$http, this.$router),
            validation: new SaldoProdutoValidation(this.msgs),

            isLoading: false,
            isSaving: false,
            msgs: [],

            estoque: {
                idsaldoproduto: this.idsaldoproduto,
                idproduto: +this.$route.params.id,
                idempresa: null,
                saldo: null,
                saldominimo: null,
                replicapda: null,
                empresa: null,
            },

            cantEdit: false,
            isUpdate: false,
            empresaSelect: [],
            empresaSelected: null,
        };
    },
    created() {
        this.isUpdate = this.idsaldoproduto != null;

        if (this.isUpdate) {
            if (this.integracao) this.cantEdit = this.integracao;
            if (!this.permissao.update) this.cantEdit = !this.permissao.update;

            this.carregarDados();
        } else {
            this.carregarEmpresas();
        }
    },
    methods: {
        save() {
            if (this.validation.validate(this.estoque, this.empresaSelected, this.$refs)) {
                let estoqueTemp = Object.assign({}, this.estoque);
                estoqueTemp = this.mapTosave(estoqueTemp);
                estoqueTemp.idempresa = this.empresaSelected.id;
                this.isSaving = true;
                this.service
                    .save(estoqueTemp)
                    .then((value) => {
                        if (value.message == null) {
                            let msg = this.$t(
                                    this.estoque.idsaldoproduto != null
                                        ? 'msg-edit-sucesso-n'
                                        : 'msg-save-sucesso-n', 
                                    { n: this.$t('aba-estoque') }
                                );

                            this.msgs.push(new Message('success', msg, true, false));
                            this.$emit('isChanged', false);

                            setTimeout(() => {
                                this.$emit('fecharModal', true);
                            }, 1500);
                        } else {
                            if (this.$t(value.message)) {
                                this.msgs.push(new Message('alert', value.message, true));
                            } else {
                                this.msgs.push(
                                    new Message('error', 'msg-problema-realizar-acao', true)
                                );
                            }
                        }
                    })
                    .catch((e) => {
                        console.error('Erro ao salvar: ' + e);
                        this.msgs.push(new Message('error', 'msg-erro-salvar', true));
                    })
                    .finally(() => {
                        this.isSaving = false;
                        this.isLoading = false;
                    });
            } else {
                this.msgs.push(new Message('alert', 'msg-campos-obrigatorios', true));
                this.isLoading = false;
            }
        },
        carregarDados() {
            this.isLoading = true;
            this.isLoadingEdit = true;
            this.service
                .find(this.idsaldoproduto)
                .then((body) => {
                    this.estoque.idsaldoproduto = body.content.idsaldoproduto;
                    this.estoque.idproduto = body.content.idproduto;
                    this.estoque.idempresa = body.content.empresa ? body.content.empresa.id : null;
                    this.estoque.saldo = body.content.saldo;
                    this.estoque.saldominimo = body.content.saldominimo;
                    this.estoque.replicapda = body.content.replicapda;

                    if (this.estoque.replicapda != 3) this.cantEdit = true;

                    this.selecionarEmpresa();
                })
                .catch((e) => {
                    this.msgs.push(new Message('error', 'msg-erro-load', true));
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        selecionarEmpresa() {
            if (this.estoque.idempresa != null) {
                let empresa = this.$store.state.user.empresas.filter(
                    (f) => (f.id = this.estoque.idempresa)
                );
                if (empresa.length > 0) {
                    this.empresaSelected = empresa[0];
                } else {
                    this.cantEdit = true;
                }
            } else {
                this.cantEdit = true;
            }
        },
        carregarEmpresas() {
            this.isLoading = true;
            this.isLoadingEdit = true;
            this.empresaService
                .findEmpresasNotInSaldoProduto(
                    this.$route.params.id,
                    this.$store.state.user.idusuarioerp
                )
                .then((body) => {
                    this.empresaSelect = Object.assign(body.content);
                })
                .catch((e) => {
                    this.msgs.push(new Message('error', 'msg-erro-load', true));
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        generateId(numberId) {
            return this.$route.name + '-estoque-' + numberId;
        },
        fecharModal() {
            this.$emit('fecharModal', true);
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 30px 30px;
}
</style>
